import { useEffect } from "react";
import { Link, Navigate, useParams } from "react-router-dom";
import { AppLayout } from "../../components/layout/Header";
import { getClientByCode, portalPathForClient } from "../../js/api/clientAccess";
import { clientPortalAllowed } from "../../js/api/accountLifecycle";
import { agentIdForClient, writeClientPortal } from "../../js/hooks/useClientPortal";
import { resolveAdvisorForClient } from "../../js/api/proIdentity";
import { getAccountSettings } from "../../js/api/accountSettings";
import { preferenceProgress } from "../../js/utils/formatters";
import { sellerProgress } from "../../js/utils/sellerSteps";

function readBuyerProgress() {
  try {
    const raw = JSON.parse(localStorage.getItem("dh_buyer_current") || "null");
    return preferenceProgress(raw?.preferences || {});
  } catch {
    return 0;
  }
}

function readSellerProgress() {
  try {
    const raw = JSON.parse(localStorage.getItem("dh_seller") || "null");
    return sellerProgress(raw || {});
  } catch {
    return 0;
  }
}

export default function ClientPortalPage({ kind }) {
  const { clientCode } = useParams();
  const client = getClientByCode(clientCode);
  useEffect(() => {
    if (client && client.role_type === kind) writeClientPortal(client);
  }, [client, kind]);
  if (!client) {
    return (
      <AppLayout variant="public">
        <article className="card account-card">
          <h1>Portal not found</h1>
          <p>That Client ID is not on this device. Ask your advisor for the current ID.</p>
          <Link to="/">Return home</Link>
        </article>
      </AppLayout>
    );
  }
  if (!clientPortalAllowed(client)) {
    return (
      <AppLayout variant="public">
        <article className="card account-card">
          <h1>Portal paused</h1>
          <p>This portal is quietly paused. Please contact your advisor’s office.</p>
          <Link to="/">Return home</Link>
        </article>
      </AppLayout>
    );
  }
  if (client.role_type !== kind) {
    return <Navigate to={portalPathForClient(client)} replace />;
  }
  const advisor = resolveAdvisorForClient(agentIdForClient(client));
  const settings = advisor?.userId ? getAccountSettings(advisor.userId).portal : {};
  const progress = kind === "seller" ? readSellerProgress() : readBuyerProgress();
  const continueTo = kind === "seller" ? `/seller/home?portal=1&client=${client.client_code}` : `/start?portal=1&client=${client.client_code}`;

  return (
    <AppLayout variant="client">
      <article className="client-portal card">
        <p className="home-kicker">{kind === "seller" ? "Seller portal" : "Buyer portal"}</p>
        <h1>Hello{client.name ? `, ${client.name.split(" ")[0]}` : ""}</h1>
        <p className="page-lead">This is your checklist only. The professional desk is not available here.</p>
        {advisor && settings.showPhone !== false && advisor.phone ? <p>{advisor.phone}</p> : null}
        {advisor && settings.showEmail !== false && advisor.email ? <p>{advisor.email}</p> : null}
        {advisor && settings.showOffice !== false && advisor.officeName ? <p>{advisor.officeName}</p> : null}
        {settings.showProgress !== false ? <p className="muted">Progress {progress}%</p> : null}
        <div className="btn-row">
          <Link className="primary-btn" to={continueTo}>
            Continue my checklist
          </Link>
          {settings.allowMessages !== false ? (
            <Link className="ghost-btn" to="/client/messages">
              Messages
            </Link>
          ) : null}
        </div>
        <p className="muted">Client ID {client.client_code}</p>
      </article>
    </AppLayout>
  );
}
